import { CalendarDate } from "../../periods";

// The days clicked on the calendar so far
export interface DraftRange {
  firstDay?: CalendarDate;
  lastDay?: CalendarDate;
}

export const isDraftRangeComplete = ({ firstDay, lastDay }: DraftRange): boolean =>
  Boolean(firstDay && lastDay);
